import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    banks: `${APP_CONFIG.sales_cluster}/v1/payments/banks`,
  },
}
